import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL + "/auth";

export const sendOtp = async (email) => {
  const res = await axios.post(`${API_URL}/send-otp`, { email });
  return res.data;
};

export const resendOtp = async (email) => {
  const res = await axios.post(`${API_URL}/resend-otp`, { email });
  return res.data;
};

export const register = async (userData) =>{

  const res= await axios.post(`${API_URL}/register`,userData);
  return res;

};

export const resetPassword = async (data) => {
  const res = await axios.post(`${API_URL}/reset-password`, data);
  return res.data;
};

export const sendOtpReset = async (email) => {
  const res = await axios.post(`${API_URL}/send-otp-reset`, { email });
  return res.data;
};

export const login = async ({ email, password }) => {
  const res = await axios.post(`${API_URL}/login`, { email, password });
  
  return res.data;
};








